import {Component, OnInit, Inject, ChangeDetectionStrategy} from '@angular/core';
import {AttachmentService} from '../../core/attachment.service';
import {EditUserModel} from '../../users/edit-user.model';
import {UserService} from '../../core/user.service';
import {ActivatedRoute} from '@angular/router';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-manage-mfa-modal',
    templateUrl: './manage-mfa-modal.component.html',
    styleUrls: ['./manage-mfa-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ManageMfaModalComponent implements OnInit {
  public userData: EditUserModel;
  public mobileCountryCode = 1;
  public mobilePhone;

  constructor(public dialogRef: MatDialogRef<ManageMfaModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, 
    private attachmentService: AttachmentService,
    private userService: UserService,
    private route: ActivatedRoute) { 
      if(this.data.userData){
        this.userData = this.data.userData;
        this.userData.mfaType = 2;
      }
     }

  public ngOnInit() {

  }

  public onDone()
  {
    const profile = new EditUserModel(this.userData);
    this.userService.saveProfile(profile).subscribe(() => {
    });
    this.dialogRef.close();
  }
}
